module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Esposizione_Fiera-BN.475e2d91.svg";